// Common
import { Component } from '@angular/core';

// Services
import { StitchServiceFactory } from '@modules/common/factories/stitch-service.factory';
import { MessageFoldersService } from '@modules/messages/services/message-folders.service';
import { MessagesService } from '@modules/messages/services/messages.service';
import { EmailAddressFeaturesService } from '@modules/messages/services/email-address-features.service';
import { CalendarsService } from '@modules/calendar-app/services/calendars.service';
import { EventsService } from '@modules/calendar-app/services/events.service';
import { ProjectsService } from '@modules/tasks/services/projects.service';
import { TasksService } from '@modules/tasks/services/tasks.service';
import { NotebooksService } from '@modules/notes/services/notebooks.service';
import { NotesService } from '@modules/notes/services/notes.service';
import { GroupsService } from '@modules/contacts/services/groups.service';
import { ContactsService } from '@modules/contacts/services/contacts.service';
import { FoldersService } from '@modules/files/services/folders.service';
import { FilesService } from '@modules/files/services/files.service';
import { KnowledgePanelService } from '@modules/knowledge/services/knowledge-panel.service';
import { CalendarSummariesCache } from '@modules/calendar-app/services/calendar-summaries.cache';
import { FolderSummariesCache } from '@modules/files/services/folder-summaries.cache';
import { SheetFolderSummariesCache } from '@modules/sheets/services/sheet-folder-summaries.cache';
import { SheetFoldersService } from '@modules/sheets/services/sheet-folders.service';
import { SheetsService } from '@modules/sheets/services/sheets.service';
import { GroupSummariesCache } from '@modules/contacts/services/group-summaries.cache';
import { MessageFolderSummariesCache } from '@modules/messages/services/message-folder-summaries.cache';
import { NotebookSummariesCache } from '@modules/notes/services/notebook-summaries.cache';
import { ProjectSummariesCache } from '@modules/tasks/services/project-summaries.cache';
import { APPLICATION_SCOPE_TOKEN, ApplicationScope } from '@modules/common/types/ApplicationScope';

@Component({
  selector: 'stch-shared-layout',
  templateUrl: './shared-layout.component.html',
  styleUrls: ['./shared-layout.component.less'],
  providers: [
    StitchServiceFactory,
    // Per-type batched summary caches, next to the services they read through.
    CalendarSummariesCache,
    FolderSummariesCache,
    SheetFolderSummariesCache,
    GroupSummariesCache,
    MessageFolderSummariesCache,
    NotebookSummariesCache,
    ProjectSummariesCache,
    MessageFoldersService,
    MessagesService,
    EmailAddressFeaturesService,
    CalendarsService,
    EventsService,
    ProjectsService,
    TasksService,
    NotebooksService,
    NotesService,
    GroupsService,
    ContactsService,
    FoldersService,
    FilesService,
    SheetFoldersService,
    SheetsService,
    KnowledgePanelService,
    {
      provide: APPLICATION_SCOPE_TOKEN,
      useValue: ApplicationScope.SHARED,
    },
  ],
  standalone: false,
})
export class SharedLayoutComponent {}
